import { graphql } from 'gatsby';
import React, { Component } from 'react';
import SaveModal from '../../shared/components/modals/save-modal/save-modal';
import Layout from "../../shared/components/organisms/layout/layout";
import SEO from "../../shared/seo";
import { siteUrl } from '../../shared/utils/siteUrl';
import { unicodeUtil } from '../../shared/utils/unicodeUtil';
import ContentArticleFC from '../organisms/content-article-fc/content-article-fc';

export class FemaleCareTemplate extends Component {

  constructor(props) {
    super(props);
    this.state = {
      mobile: null,
      bannerInfo: this.props.pageContext.bannerDeInterna,
      isLog: false,
      scrollValue: 0,
      updatedAt: this.props.data.allContentfulNolArticulos.edges[0].node.fechaDePublicacion,
      activeModalSave: false,
      modalActive: null,
      schemaOrgJSONLD: {
        "@context": "https://schema.org",
        "@type": "BlogPosting",
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": siteUrl + '/entre-nosotras/' + this.props.pageContext.slug
        },
        "headline": unicodeUtil(this.props.pageContext.metaTitulo),
        "description": unicodeUtil(this.props.pageContext.metaDescripcion.metaDescripcion),
        "image": this.props.pageContext.metaImagen.file.url,
        "author": {
          "@type": "Organization",
          "name": "NosotrasOnline"
        },
        "publisher": {
          "@type": "Organization",
          "name": "Grupo Familia S.A",
          "logo": {
            "@type": "ImageObject",
            "url": "/nosotrasonline.png",
            "width": "",
            "height": ""
          }
        },
        "datePublished": this.props.data.allContentfulNolArticulos.edges[0].node.fechaDePublicacion,
        "dateModified": this.props.data.allContentfulNolArticulos.edges[0].node.updatedAt
      },
    };
  }

  componentDidMount() {
    sessionStorage.setItem('LAST_SECTION', JSON.stringify({ "title": "Cuidado Femenino", "slug": "entre-nosotras/cuidado-femenino/" }))

    if (window.innerWidth < 1024) {
      this.setState({ mobile: true });
    }else{
      this.setState({ mobile: false });
    }

    window.addEventListener("resize", this.updateDimensions);
    window.addEventListener('scroll', this.handleScroll, { passive: true })

    if (typeof window !== `undefined`) {
      if (sessionStorage.getItem("slugFilter") === null) {
        sessionStorage.setItem('slugFilter', 'lo-ultimo')
        sessionStorage.setItem('titleFilter', 'Lo Último')
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
    window.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll = (event) => {
    // do something like call `this.setState` access window.scrollY etc
    this.setState({ scrollValue: window.scrollY });
  }

  updateDimensions = () => {
    if (window.innerWidth < 1024) {
      this.setState({ mobile: true });
    } else {
      this.setState({ mobile: false });
    }
  }

  setModalState = (modal) => {
    if (modal || modal === null) {
      this.setState({ modalActive: modal })
    } else {
      if (this.state.activeModalSave === false) {
        this.setState({ modalActive: <SaveModal closeModal={() => this.setState({ modalActive: null })} /> })
      } else {
        this.setState({ modalActive: null })
      }
    }
  }

  render() {
    return (
      <Layout mobile={this.state.mobile} modalActive={this.state.modalActive}>
        <SEO
          title={this.props.pageContext.metaTitulo}
          description={this.props.pageContext.metaDescripcion.metaDescripcion}
          lang={this.props.pageContext.language}
          image={this.props.pageContext.metaImagen.file.url}
          url={siteUrl + '/entre-nosotras/' + this.props.pageContext.slug}
          script={this.state.schemaOrgJSONLD}
        />

        <ContentArticleFC
          mobile={this.state.mobile}
          infoArticle={this.props.pageContext}
          scrollValue={this.state.scrollValue}
          updatedAt={this.state.updatedAt}
          isLog={this.state.isLog}
          setModalState={this.setModalState}
        />
      </Layout>
    )
  }
}

export const query = graphql`
  query GET_GENERAL_INFO ($slug: String!, $locale: String!){
    allContentfulNolArticulos(filter: {node_locale: {eq: $locale}, slug: {eq: $slug}}) {
      edges {
        node {
          updatedAt
          fechaDePublicacion
        }
      }
    }
  }
`

export default FemaleCareTemplate;